export default __webpack_public_path__ + "static/impact-ready-fill-mobile-7b953c5850a3ef4699e0c3447516c2cd.svg";